export const ADD_NEW_ADDRESS = "ADD_NEW_ADDRESS";
export const UPDATE_ADDRESS = "UPDATE_ADDRESS";
